import { apiClient, API_CONFIG } from '../../../core';
import type { ApiResponse } from '../../../shared';
import type {
  LC_ListMarksReportIn,
  LC_ListMarksReportOut,
  LC_ExportMarksReportIn,
  MarksReportExportHybridResult,
  LC_ResendMarkSupportOut,
  LC_BulkResendMarkSupportOut,
  LC_AdjustMarkIn,
  LC_AdjustMarkOut,
  MarksReportPage,
} from '../types';
import { mapMarksReportPage } from '../mappers';


export class MarksReportService {
  async list(
    params: LC_ListMarksReportIn,
    signal?: AbortSignal,
  ): Promise<ApiResponse<MarksReportPage>> {
    const endpoint = `${API_CONFIG.ENDPOINTS.ATTENDANCE.REPORTS_MARKS}/search`;

    const response = await apiClient.post<LC_ListMarksReportOut>(endpoint, params, { signal });

    if (!response.success || !response.data) {
      return { ...response, data: null };
    }

    return { ...response, data: mapMarksReportPage(response.data) };
  }

  async export(
    params: LC_ExportMarksReportIn,
  ): Promise<ApiResponse<MarksReportExportHybridResult>> {
    return apiClient.downloadBlobOrAcceptJob(
      API_CONFIG.ENDPOINTS.ATTENDANCE.REPORTS_MARKS_EXPORT,
      { method: 'POST', body: JSON.stringify(params) },
    );
  }

  async resendSupport(markId: number): Promise<ApiResponse<LC_ResendMarkSupportOut>> {
    const endpoint = `${API_CONFIG.ENDPOINTS.ATTENDANCE.REPORTS_MARKS}/${markId}/resend-support`;
    return apiClient.post<LC_ResendMarkSupportOut>(endpoint, {});
  }

  async resendSupportBulk(markIds: number[]): Promise<ApiResponse<LC_BulkResendMarkSupportOut>> {
    const endpoint = `${API_CONFIG.ENDPOINTS.ATTENDANCE.REPORTS_MARKS}/resend-support/bulk`;
    return apiClient.post<LC_BulkResendMarkSupportOut>(endpoint, { markIds: markIds.join(',') });
  }

  async adjustMark(
    markId: number,
    payload: LC_AdjustMarkIn,
  ): Promise<ApiResponse<LC_AdjustMarkOut>> {
    const endpoint = `${API_CONFIG.ENDPOINTS.ATTENDANCE.REPORTS_MARKS}/${markId}/adjust`;
    return apiClient.post<LC_AdjustMarkOut>(endpoint, payload);
  }
}

export const marksReportService = new MarksReportService();
